import { FirebaseAuthBackend, getFirebaseBackend } from 'helpers/firebase_helper';
import { Media, MediaMetaData } from 'helpers/models/media.model';
import React, { useEffect, useState } from 'react';
import Dropzone from 'react-dropzone';
import { Card, Col, Row } from 'reactstrap';
import { UploaderAcceptance } from 'utils/constants';
import Loader from './Loader';
import videoUploader from "../../assets/images/videUploader.png"
import uplaoderIcon from "../../assets/images/iIcon.svg"
import VideoViewer from './VideoViewer';
import { toast } from 'react-toastify';
import { getS3Upload } from 'helpers/backend_helper';

type UpdateMediaFunction = (media: Media | undefined) => void;

type MediaUploaderProps = {
    onMediaUpdate: UpdateMediaFunction;
    initialMedia?: Media;
    detaIdProps?: string
};

const VideoUploader: React.FC<MediaUploaderProps> = ({
    onMediaUpdate,
    initialMedia,
    detaIdProps,
}) => {
    const [media, setMedia] = useState<Media>();
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const firebaseHelper: FirebaseAuthBackend | null = getFirebaseBackend();
    const acceptance: any = UploaderAcceptance.video;
    const [errorMessage, setErrorMessage] = useState<string>("");
    const [isViewerOpen, setViewerOpen] = useState(false);
    const [currentImage, setCurrentImage] = useState("");

    useEffect(() => {
        if (initialMedia) {
            setMedia(initialMedia)
        }
    }, []);

     const getUploadUrl = async (file: File): Promise<string | null> => {
            try {
                const fileName = encodeURIComponent(file.name);
    
                const res: any = await getS3Upload(fileName,file.type); // Your API returns { uploadUrl }
                const uploadUrl = res?.data?.uploadUrl;
    
                if (uploadUrl) {
    
                    const myHeaders = new Headers();
                    myHeaders.append("Content-Type", file.type);
                    const requestOptions: any = {
                        method: "PUT",
                        headers: myHeaders,
                        body: file,
                        redirect: "follow"
                    };
                    await fetch(uploadUrl, requestOptions);
                }
    
                return res.data.fileUrl;
            } catch (err) {
                console.error("S3 upload error", err);
                return null;
            }
        };

    const handleAcceptedFiles = async (files: any) => {
    if (media) {
        toast.error("Only one video can be uploaded at a time.", {
            autoClose: 1000,
        });
        return;
    }

        if (files.length === 0) {
            toast.error("Only one image can be uploaded at a time.", {
                autoClose: 1000,
            });
            return;
        }
        const file = files[0];
        if (file.type !== 'video/mp4') {
            setErrorMessage('Only MP4 files are allowed.');
            return;
        }
        if (file.size > 10485760) {
            setErrorMessage('File size should be less than 10MB.');
            return;
        }
        const video = document.createElement('video');
        video.src = URL.createObjectURL(file);
        video.onloadedmetadata = async () => {
            if (video.duration > 60) {
                setErrorMessage('Video length must be 60 seconds or less.');
                return;
            }
            if (video.videoWidth < 480 || video.videoHeight < 480) {
                setErrorMessage('Video resolution must be at least 480x480 px.');
                return;
            }
            setIsLoading(true);
            setErrorMessage('');
            const url = await getUploadUrl(file);
            if (url) {
                updateMedia(new Media(
                    url,
                    new MediaMetaData(
                        file.height || video.videoHeight,
                        file.width || video.videoWidth,
                        file.type || "file",
                        file.name.split('.').pop() || "",
                        file.name || "",
                        file.duration || video.duration
                    ),
                ))
            }
            setIsLoading(false);
        };
    }

    const handleDeleteFile = () => {
        updateMedia(undefined);
    };

    const updateMedia = (obj: Media | undefined) => {
        setMedia(obj);
        onMediaUpdate(obj);
    }

    const closeViewer = () => {
        setViewerOpen(false);
    };

    const openViewer = (videoUrl: string) => {
        setCurrentImage(videoUrl);
        setViewerOpen(true);
    };

    return (
        <React.Fragment>
            <div className="mb-4">
                {<Dropzone
                    onDrop={(acceptedFiles) => {
                        handleAcceptedFiles(acceptedFiles);
                    }}
                    // disabled={media !== undefined}
                    accept={acceptance}
                    maxFiles={1} // Only allow one file
                >
                    {({ getRootProps, getInputProps }) => (
                        <div className=" gap-3 mt-2 ">
                            {isLoading && <Loader />}
                            {!isLoading && <div className='VideoUploader_flex d-flex justify-content-between align-items-start'>
                                <div className='videoUpload-width w-25'>
                                <div className="d-flex align-items-center border-2 cursor-pointer border-dashed  p-3 rounded d-flex justify-content-start align-items-center" style={{ border: " #E2E7EA", flexDirection: "column", width: "100%", height: "230px " }} data-testing-id={detaIdProps} {...getRootProps()}>
                                    <div className='d-flex justify-content-between align-items-center w-100 mb-5'><h5 className='fw-bold m-0 p-0'>Upload Video</h5>
                                     {/* <img src={uplaoderIcon} style={{ width: "20px", height: "20px" }} alt="" />  */}
                                     </div>
                                    <input {...getInputProps()} disabled={media && undefined} />
                                    {/* <i className="las la-plus fs-1 text-success"></i> */}
                                    <div className='text-center'>
                                        <img src={videoUploader} style={{ width: "90px", height: "60px", marginBottom: "10px" }} alt="" />
                                        <h5 className='mb-1' style={{ fontSize: "16px", fontWeight: "500", color: "#a2b1c3" }}>Upload or Drop file here.</h5>
                                        <h5 className='text-center' style={{ fontSize: "16px", fontWeight: "500", color: "#a2b1c3" }}>Max file size: 10 MB</h5>
                                    </div>
                                </div>
                                </div>
                                <div className="m-10 videoBox">
                                    <ul className="m-0 mt-3 p-0 px-2 gx-5">
                                        <li>Min size: 480x480 px. Max video length: 60 seconds. Max file size: 10MB.</li>
                                        <li>Supported Format: mp4</li>
                                        <li>New Video might take up to 36 hrs to be approved.</li>
                                    </ul>
                                </div>
                            </div>}
                                
                            {errorMessage && <div className="text-danger mt-2">{errorMessage}</div>}
                        </div>
                    )}
                </Dropzone>}
                {media && <div className="list-unstyled mb-0" id="file-previews" style={{ width: "300px" }}>
                    <div
                        className="mt-1 dz-processing dz-image-preview dz-success mt-4 dz-complete  d-flex justify-content-between align-items-center gap-1"
                        style={{ border: "2px dashed #E2E7EA", width: "300px", height: "51px ", padding: "10px", borderRadius: "10px" }}
                        key={media.url}
                    >
                        <div
                            onClick={() => openViewer(media.url)}

                        >
                            <video
                                // controls
                                className="rounded bg-light cursor-pointer"
                                src={media.url}
                                data-testing-id="videoSelect_VideoUploader"
                                style={{ width: "60px", height: "40px" }}

                            />
                        </div>
                        <VideoViewer isOpen={isViewerOpen} videoUrl={currentImage} toggle={closeViewer} />
                        <p
                            className="mb-0 mt-2" style={{ width: "43vh", textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: 'hidden' }}>
                            <strong>{media.metaData && media.metaData.name}</strong>

                        </p>

                        <div className=" d-flex justify-content-end " onClick={() => handleDeleteFile()}>
                            {/* <i className="bx bx-trash bg-red text-white rounded bg-danger p-1 cursor-pointer" data-testing-id="delteVideo_VideoUploader"></i> */}
                            <i className='bx bx-x text-danger fs-4 fw-bolder cursor-pointer' data-testing-id="delteVideo_VideoUploader"></i>
                        </div>
                    </div>

                </div>}
            </div>
        </React.Fragment>
    );
};

export default VideoUploader;
